import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import { GlobalStyles } from '../../src/styles/GlobalStyles';
import { Colors } from '../../src/styles/theme';

const EditProfileScreen: React.FC = () => {
  const { t } = useTranslation();
  return (
    <View style={GlobalStyles.centeredContainer}>
      <Text style={styles.title}>{t('profile.editProfile')}</Text>
      <Text style={styles.text}>{t('profile.editProfileDescription')}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 20,
    color: Colors.text,
  },
  text: {
    fontSize: 16,
    color: Colors.text,
    marginBottom: 10,
  },
});

export default EditProfileScreen;
